exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-2bae2a82]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-2bae2a82]{display:none !important}}.o-bottom-navigation[data-v-2bae2a82]{position:relative;z-index:var(--sidebar-z-index)}@media (min-width: 1024px){.o-bottom-navigation[data-v-2bae2a82]{display:none}}.o-bottom-navigation[data-v-2bae2a82]  .sf-bottom-navigation{z-index:inherit}.o-bottom-navigation[data-v-2bae2a82]  .sf-bottom-navigation .sf-bottom-navigation-item{cursor:pointer}\n", ""]);

// exports
